function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component, register } from 'ovee.js';
var HeroHeightHelper = (_dec = register('hero-height-helper'), _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(HeroHeightHelper, _Component);

  var _super = _createSuper(HeroHeightHelper);

  function HeroHeightHelper() {
    var _this;

    _classCallCheck(this, HeroHeightHelper);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "cta", _this.$element.querySelector('[data-hero-height-include]'));

    return _this;
  }

  _createClass(HeroHeightHelper, [{
    key: "init",
    value: function init() {
      this.updateHeightVar();
      window.addEventListener('resize', this.delayedResizeHandler(this.updateHeightVar, 300, 300));
    }
  }, {
    key: "delayedResizeHandler",
    value: function delayedResizeHandler(func, throttleDelay, debounceDelay) {
      var _this2 = this;

      var lastCall = 0;
      var debounceTimer = null;
      var rafId = null; // Track the last known dimensions

      var lastHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var lastWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var now = new Date().getTime();
        var currentHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        var currentWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth; // Calculate changes

        var heightChange = Math.abs(currentHeight - lastHeight);
        var widthChange = Math.abs(currentWidth - lastWidth); // Update the last known dimensions

        lastHeight = currentHeight;
        lastWidth = currentWidth; // Trigger only on significant height changes or any width change

        if (heightChange < 100 && widthChange === 0) {
          return false;
        }

        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(function () {
          if (!rafId) {
            rafId = requestAnimationFrame(function () {
              func.apply(_this2, args);
              rafId = null;
            });
          }
        }, debounceDelay);

        if (now - lastCall >= throttleDelay) {
          lastCall = now;

          if (!rafId) {
            rafId = requestAnimationFrame(function () {
              func.apply(_this2, args);
              rafId = null;
            });
          }
        }

        return false;
      };
    }
  }, {
    key: "updateHeightVar",
    value: function updateHeightVar() {
      var root = document.documentElement;

      if (this.$element && this.$element !== null) {
        var navHeight = this.$element.getBoundingClientRect().height;

        if (this.cta && this.cta !== null) {
          navHeight += this.cta.getBoundingClientRect().height;
        }

        root.style.setProperty('--hero-nav-height', "".concat(navHeight, "px"));
      } else {
        root.style.removeProperty('--hero-nav-height');
      }
    }
  }]);

  return HeroHeightHelper;
}(Component), _temp)) || _class);
export { HeroHeightHelper as default };